import { useAppSelector } from '../../store/hooks'

export const useRouter = () => {
  const router = useAppSelector((state) => state.router)
  return router
}
